


















































import { Component } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';
import LoyaltyExample from '@/components/molecules/LoyaltyExample/LoyaltyExample.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import LoyaltyConfigForm from '@/components/organisms/LoyaltyConfigForm/LoyaltyConfigForm.vue';
import Page from '@/componentsV2/molecules/Page/Page.vue';
import BusinessService from '@/api/BusinessService';

import LoyaltySetupBase from '@/views/Onboarding/Steps/LoyaltySetup/LoyaltySetupBase.vue';
import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';

import SingUpService from '@/api/SingupService';

import { updateRegistration } from '@/utils/updateRegistration';
import { validation } from '@/views/Onboarding/Steps/LoyaltySetup/validation';
import DateUtils from '@/utils/DateUtils';

import { needLaunchRewardsProgram } from '@/utils/start-guide';
import { IBusinessType } from '@/models/business';
import flagKeys from '@/constants/flagKeys';
import { IEducationPlayerProps } from '@/componentsV2/molecules/EducationPlayer/EducationPlayer';
import segmentIo from '@/utils/segment.io';
import SellCoinsService from '@/api/SellCoinsService';
import eventBus from '@/utils/eventBus';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { TCampaignStatus } from '@/models/marketingCenter/sellCoins';
import { Campaign } from '@/models/marketingCenter/sellCoins';
import {
  EAutomaticCampaignName,
  EIncentiveType,
  ESellCoinsCampaignStatus
} from '@/models/sell-coins';

@Component({
  components: {
    Typography,
    LoyaltyConfigForm,
    LoyaltyExample,
    FilledButton,
    Page
  }
})
export default class ManageLoyalty extends LoyaltySetupBase {
  signUpService = new SingUpService();
  loading = false;
  sellCoinsService = new SellCoinsService();
  iconName: string = 'warning.svg';
  campaignStatusType: TCampaignStatus = 'campaignRatioIssueActivation';
  businessService = new BusinessService();

  get educationVideo(): IEducationPlayerProps | false {
    if (
      this.businessInfo.type !== IBusinessType.BOTH ||
      !this.flags.includes(flagKeys.addWixMultipleIntegration)
    )
      return false;

    let align: any = 'left';
    if (this.$mobileCheck()) align = 'center';

    return {
      title: this.$t(`${this.tPrefix}.titleVideoTutorial`) as string,
      link: 'https://www.youtube.com/watch?v=Ma5EbPkRkFE',
      align,
      learnMoreLink: 'https://support.twism.com/hc/en-us',
      learnMoreClick: () => {
        segmentIo.track('Clicked Support Link Physical_Online Rewards', {
          Origin: 'Tutorial Video'
        });
      },
      analyticsName: 'Physical_Online Rewards'
    };
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return 'coinLoyaltySettings.manageLoyalty';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get isValidForm() {
    return validation(this.formData);
  }

  get pageTitle() {
    return this.$t(`${this.tPrefix}.title`);
  }

  async changeCampaignStatus(oldCampaignId: string, newCampaignId: string) {
    this.loading = true;

    this.sellCoinsService.disableInterception();

    await this.sellCoinsService.changeCampaignStatus(oldCampaignId);
    await this.sellCoinsService.changeCampaignStatus(newCampaignId);
  }

  newCampaignEndDateFormatted(newCampaignData: Campaign) {
    if (newCampaignData && newCampaignData.endDate) {
      return DateUtils.formattedDate({
        date: newCampaignData.endDate
      });
    }

    return 'No expiration date';
  }

  formatDate(date: any) {
    if (date && date !== null) {
      const [formatedDate] = date.split('T');
      return DateUtils.formattedDate({ date: formatedDate });
    }

    return 'No expiration date';
  }

  openCampaignStatusManagementModal(
    activeCampaignData?: any,
    newCampaignData?: any
  ) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'SellCoinsCampaignStatusManagementModal'
      }),
      {
        iconName: this.iconName,
        campaignType: this.campaignStatusType,
        activeCampaignData,
        newCampaignData: {
          ...newCampaignData,
          endDate: this.newCampaignEndDateFormatted(newCampaignData)
        },
        onConfirm: async (optionSelected: string) => {
          const payload = {
            coinPurchaseRatio: this.coinPurchaseRatio,
            coinRewardPercentage: this.percentInCoins
          };
          const { data } = await this.signUpService.setupRules(payload);

          if (optionSelected === 'createNewCampaign') {
            await this.sellCoinsService.deactivateActiveCampaign();

            const listOfCampaigns = await this.sellCoinsService.listOfCampaigns();
            const matchCampaign = listOfCampaigns.data.items.find(
              (item: any) =>
                item.incentiveValue ===
                  parseFloat(newCampaignData.incentiveValue) &&
                item.status === ESellCoinsCampaignStatus.INACTIVE
            );

            if (matchCampaign) {
              await this.sellCoinsService.changeCampaignStatus(
                matchCampaign.id
              );
            } else {
              await this.sellCoinsService.createSellingCoinsCampaign({
                name: EAutomaticCampaignName.loyalt,
                incentiveValue: parseFloat(newCampaignData.incentiveValue),
                incentiveType: EIncentiveType.BONUS,
                automaticallyCreated: true
              });
            }
          } else if (optionSelected === 'disableSellCoins') {
            const response = await this.businessService.updateSellCoins(
              !this.businessInfo.sellCoins,
              DashboardScreen.Loyalt
            );

            this.$store.dispatch('business/SET_BUSINESS_INFO', {
              ...this.businessInfo,
              sellCoins: response.data.sellCoins
            });
          }

          this.submit();
        }
      }
    );
  }

  async next() {
    this.loading = true;
    try {
      const payload = {
        coinPurchaseRatio: this.coinPurchaseRatio,
        coinRewardPercentage: this.percentInCoins
      };
      const { data } = await this.signUpService.setupRules(payload);

      const response = await this.sellCoinsService.getActiveCampaign();
      const activeCampaign = response.data;

      const listOfCampaigns = await this.sellCoinsService.listOfCampaigns();
      const activeCampaignWithNewLoyalt = listOfCampaigns.data.items.find(
        (item: { incentiveValue: number; status: ESellCoinsCampaignStatus }) =>
          item.incentiveValue === parseFloat(data.coinRewardPercentage) &&
          item.status === ESellCoinsCampaignStatus.ACTIVE
      );

      if (
        this.flags.includes(flagKeys.dashboardSellCoinsAndLoyaltVerify) &&
        this.businessInfo.sellCoins &&
        ((activeCampaign.incentiveValue &&
          data.coinRewardPercentage > activeCampaign.incentiveValue) ||
          activeCampaign.incentiveValue === 0) &&
        !activeCampaignWithNewLoyalt
      ) {
        activeCampaign.endDate = this.formatDate(activeCampaign.endDate);
        const newCampaign = {
          ...activeCampaign,
          incentiveValue: parseFloat(data.coinRewardPercentage).toString()
        };

        this.openCampaignStatusManagementModal(activeCampaign, newCampaign);
      } else {
        this.submit();
      }
    } finally {
      this.loading = false;
    }
  }

  async submit() {
    const payload = {
      coinPurchaseRatio: this.coinPurchaseRatio,
      coinRewardPercentage: this.percentInCoins
    };

    this.loading = true;

    try {
      const { data } = await this.signUpService.setupRules(payload);

      this.$store.dispatch('business/SET_BUSINESS_INFO', {
        ...this.businessInfo,
        coinPurchaseRatio: data.coinPurchaseRatio,
        coinRewardPercentage: data.coinRewardPercentage
      });

      updateRegistration('manage-rewards');
      this.$notification(
        String(this.$t(`${this.tPrefix}.successNotification`)),
        'success'
      );

      this.$analytics({
        eventCategory: 'Coin & Loyalty Settings - Rewards Rate',
        eventLabel: `Clicked on the "Save" button`,
        eventAction: 'click'
      });
    } finally {
      this.loading = false;
    }
  }
}
